import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserSession } from './store/reducers/sessionReducer';
import Loading from './components/loading';

function Session({ children }) {
    const dispatch = useDispatch();
    const { isLoading: isSessionLoading } = useSelector((state) => state.session);

    useEffect(() => {
        dispatch(fetchUserSession());
    }, [dispatch]);

    const authGuardEnabled = window._env_?.REACT_APP_ROUTE_AUTH_GUARD === 'true' || process.env.REACT_APP_ROUTE_AUTH_GUARD === 'true';

    if (authGuardEnabled && isSessionLoading) {
        return <Loading />;
    }

    return <>{children}</>;
}

export default Session;
